import { Directive, Input, } from '@angular/core';
import * as i0 from "@angular/core";
/**
 * File fields cannot be managed via the EE. We never output "editable."
 */
export class FileDirective {
    viewContainer;
    templateRef;
    field;
    viewRef;
    constructor(viewContainer, templateRef) {
        this.viewContainer = viewContainer;
        this.templateRef = templateRef;
    }
    ngOnChanges(changes) {
        if (changes.field) {
            if (!this.viewRef) {
                this.viewContainer.clear();
                this.viewRef = this.viewContainer.createEmbeddedView(this.templateRef);
            }
            this.updateView();
        }
    }
    updateView() {
        const field = this.field;
        if (!field || (!field.value && !field.src)) {
            return;
        }
        const file = field.src ? field : field.value;
        this.viewRef.rootNodes.forEach((node) => {
            if (!file)
                return;
            node.href = file.src;
            if (node.innerHTML === '') {
                node.innerHTML = file.title || file.displayName;
            }
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileDirective, deps: [{ token: i0.ViewContainerRef }, { token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: FileDirective, selector: "[scFile]", inputs: { field: ["scFile", "field"] }, usesOnChanges: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[scFile]' }]
        }], ctorParameters: () => [{ type: i0.ViewContainerRef }, { type: i0.TemplateRef }], propDecorators: { field: [{
                type: Input,
                args: ['scFile']
            }] } });
